import React from "react";
import MAP_IMAGE from "../../../assets/img/3 Offices - Montana Map.png";

// import styled components
import { LocationAddress, LocationMap, LocationWrapper } from "./styled";

const offices = [
  {
    city: "Bozeman",
    addressLine1: "1351 Stoneridge Drive, Suite C",
    addressLine2: "Bozeman, MT 59718",
  },
  {
    city: "Billings",
    addressLine1: "3421 Montana Avenue, Suite 4",
    addressLine2: "Billings, MT 59101",
  },
  {
    city: "Helena",
    addressLine1: "432 Last Chance Gulch, 2nd Floor, Unit B",
    addressLine2: "Helena, MT 59601",
  },
];

function Location() {
  return (
    <LocationWrapper id="nav-location">
      <LocationAddress>
        <h2>Our Offices</h2>
        {offices.map((office) => (
          <div className="group" key={office.city}>
            <div className="star">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 50 50" fill="red">
                <polygon points="25,1 31,18 50,18 34,29 40,46 25,36 10,46 16,29 1,18 20,18" />
              </svg>
            </div>
            <div className="test">
              <h3>{office.city}</h3>
              <p>
                <a>
                  {office.addressLine1}
                  <br />
                  {office.addressLine2}
                </a>
              </p>
            </div>
          </div>
        ))}
      </LocationAddress>
      <LocationMap>
        <div className="duh">
          <img src={MAP_IMAGE} alt="Map showing the Bozeman, Billings, and Helena Montana offices" />
        </div>
      </LocationMap>
    </LocationWrapper>
  );
}

export default Location;
